//* 语言环境中间件
//* 当响应头携带X-Custom-Language时，会根据请求头中的Referer是否同源来判断当前请求是否更换语言环境
export default defineNuxtRouteMiddleware(async (to, from) => {
    //* 请求头数据初始化
    const headers = useRequestHeaders();
    const language = headers["x-custom-language"];
    //* 检测成功后的处理函数
    const success = () => {
        const result = routerResolve(to.fullPath, language);
        if (typeof result.route != "string" && result.route?.meta?.routeLanguage == language) {
            return navigateTo(result.route);
        }
    };

    //* 检测是否存在对应的语言路由
    if (["zh", "en"].includes(language) && to.meta.routeLanguage != language) {
        try {
            const url = new URL(headers.referer);
            if (url.host != headers.host) {
                return success();
            }
        } catch {
            return success();
        }
    }
});
